import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ProductTeaser",
    component: () => (__SERVER__ ? require("./product-teaser-view") : import("./product-teaser-view"))
});

export default definition;
